/* tslint:disable */
/* eslint-disable */
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface NoteData
 */
export interface NoteData {
    /**
     * 
     * @type {string}
     * @memberof NoteData
     */
    action: NoteDataActionEnum;
    /**
     * 
     * @type {string}
     * @memberof NoteData
     */
    notes: string | null;
}

/**
* @export
* @enum {string}
*/
export enum NoteDataActionEnum {
    Append = 'Append',
    Replace = 'Replace'
}


/**
 * Check if a given object implements the NoteData interface.
 */
export function instanceOfNoteData(value: object): value is NoteData {
    if (!('action' in value) || value['action'] === undefined) return false;
    if (!('notes' in value) || value['notes'] === undefined) return false;
    return true;
}

export function NoteDataFromJSON(json: any): NoteData {
    return NoteDataFromJSONTyped(json, false);
}

export function NoteDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): NoteData {
    if (json == null) {
        return json;
    }
    return {
        
        'action': json['action'],
        'notes': json['notes'],
    };
}

  export function NoteDataToJSON(json: any): NoteData {
      return NoteDataToJSONTyped(json, false);
  }

  export function NoteDataToJSONTyped(value?: NoteData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'action': value['action'],
        'notes': value['notes'],
    };
}

